export default {"src":"/_next/static/media/phone-icon.8f1af1ab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};